<template>
  <div
    class="h5-header-search"
    :class="`h5-header-search--${size}`"
  >
    <div
      v-if="showLanguage"
      @click.stop="showChangeLanguageAndCurrency = true"
      class="h5-header-search-language"
    >
      <Icon
        class="icon"
        name="icon-language-glabal-l"
      />
      {{ language.current.toLocaleUpperCase() }}
      <Icon
        class="icon2"
        name="arrow-down-l-2"
      />
    </div>
    <div class="h5-header-search-input">
      <input
        @click="searchFocus = true"
        :value="text"
        placeholder="🔍 Search anything you want"
        type="text"
      >
    </div>
    <div
      @click.stop="photoClick"
      class="h5-header-search-photo"
    >
      <Icon name="picture-l" />
    </div>
    <div
      class="h5-header-search-search"
      @click="searchFocus = true"
    >
      <img
        src="@/assets/H5/home/search.svg"
        alt=""
      >
    </div>
    <ChangeLanguageAndCurrency
      v-model="showChangeLanguageAndCurrency"
    />
    <!-- 图片搜索下拉框 -->
    <ImageSearchDropdown
      v-model:show="imageSearchDropdownShow"
      class="image-search-dropdown"
      ref="imageSearchDropdownRef"
    />
    <SearchFocus
      v-if="searchFocus"
      @back="searchFocus = false"
    />
  </div>
</template>

<script setup>
import { buriedPointUtil } from '@/utils/utils'
import { ChangeLanguageAndCurrency } from '../ChangeLanguageAndCurrency'
import ImageSearchDropdown from './ImageSearchDropdown.vue'
import { Icon } from '@/components/Icon'
import { useLanguageStore } from '@/pinia/language'
import SearchFocus from './SearchFocus.vue'

defineProps({
  showLanguage: {
    type: Boolean
  },
  text: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: 'medium'
  }
})

defineEmits(['click'])

const showChangeLanguageAndCurrency = ref(false)

const imageSearchDropdownShow = ref(false)

const language = useLanguageStore()

const searchFocus = ref(false)

onMounted(() => {
  window.addEventListener('click', closeImageSearchDropdown)
  window.addEventListener('scroll', closeImageSearchDropdown)
})

onUnmounted(() => {
  window.removeEventListener('click', closeImageSearchDropdown)
  window.removeEventListener('scroll', closeImageSearchDropdown)
})

const closeImageSearchDropdown = () => {
  imageSearchDropdownShow.value = false
}

const photoClick = () => {
  buriedPointUtil({ eventId: 'MPSC202' })
  imageSearchDropdownShow.value = !imageSearchDropdownShow.value
}
</script>

<style lang="less" scoped>
.h5-header-search {
  position: relative;
  height: 40px;
  background-color: #FFFFFF;
  border-radius: e("calc(infinity * 1px)");
  padding-right: 4px;
  display: flex;
  align-items: center;

  &--small {
    height: 36px;

    .h5-header-search-photo {
      margin-right: 6px;
      font-size: 24px;
    }
  }

  &-language {
    padding-left: 12px;
    display: flex;
    align-items: center;
    gap: 2px;
    height: 18px;
    line-height: 18px;
    border-right: 0.5px solid #E4E6EB;
    font-family: mon-700;
    font-size: 12px;
    color: #052785;
    padding-right: 6px;
    .icon {
      flex-shrink: 0;
      font-size: 20px;
    }
    .icon2 {
      flex-shrink: 0;
      font-size: 14px;
    }
  }
  &-input {
    flex: 1;
    font-size: 12px;
    font-family: mon-500;
    font-weight: 500;
    color: #6E717A;
    line-height: 40px;

    input {
      outline: none;
      border: none;
      height: 40px;
      padding-left: 8px;
      padding-right: 6px;
      box-sizing: border-box;
      font-family: mon-600;
      font-size: 12px;
      color: #232323;
      width: 100%;
      background: transparent;

      &::placeholder {
        font-family: mon-500;
      }
    }
  }
  &-photo {
    display: flex;
    align-items: center;
    margin-right: 8px;
    font-size: 28px;
    color: #969AA3;
  }

  &-search {
    width: 44px;
    height: 28px;
    border-radius: 16px;
    background-color: #F57231;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
}
</style>
